import { store } from "../app/store";
import axios, { AxiosError } from "axios";
import { setToken } from "../entities/Admin/model";
import { apiUrl } from "./config";

export const $api = axios.create({
  baseURL: apiUrl,
});

$api.interceptors.request.use(async (request) => {
  let token = localStorage.getItem("token");
  if (token) {
    request.headers.Token = `${token}`;
  }
  return request;
});

// if response was with refreshed token, than set it
$api.interceptors.response.use(
  (response) => {
    if (response.data.token_refreshed) {
      store.dispatch(setToken(response.data.token));
    }
    return response;
  },
  async (error) => {
    if (error?.response?.status === 401) {
      // Token is dead (expired / rejected by IdP, e.g. after the
      // Keycloak→Zitadel migration). Drop it and bounce to login.
      localStorage.removeItem("token");
      window.dispatchEvent(new CustomEvent("auth:unauthorized"));
    }
    throw error;
  }
);
